import { styled } from 'baseui'

export const SaveArea = styled('div', {
  display: 'flex',
  alignItems: 'center',
  gap: '10px',
  marginLeft: 'auto',
  marginTop: '14px',
  boxSizing: 'border-box',
  height: '42px',
})
